/**
 * This file is a copy of KeywordAnalysisFilters.tsx from app/pages/keyword-analysis/
 * It will be refactored in the future
 */

import type { RawParams } from "@uirouter/react";
import autobind from "autobind-decorator";
import find from "lodash/find";
import get from "lodash/get";
import { connect } from "react-redux";

import { durationFilterDSSelected, webSourceFilterDSSelected } from "app/actions/usersFiltersSelectionActions";
import { swSettings } from "app/common/services/swSettings";
import { preparePresets } from "app/components/dashboard/widget-wizard/components/DashboardWizardDuration";
import { PeriodOverPeriodWrapper } from "app/components/duration-selector/period-over-period/PeriodOverPeriodWrapper";
import { CountryFilter } from "app/components/filters-bar/country-filter/CountryFilter";
import { FiltersBase } from "app/components/filters-bar/FiltersBase";
import { FiltersEnum } from "app/components/filters-bar/utils";
import * as utils from "app/components/filters-bar/utils";
import { WebSourceFilter } from "app/components/filters-bar/websource-filter/WebSourceFilter";
import { FiltersBar } from "app/components/React/FiltersBar/FiltersBar";
import type { IFilter } from "app/components/React/FiltersBar/FiltersBar";
import { withUIRouter } from "app/components/React/HOCs/withUIRouter";
import { PlainTooltip } from "app/components/React/Tooltip/PlainTooltip/PlainTooltip";
import UnlockModal from "app/components/React/UnlockModalProvider/UnlockModalProvider";
import { i18nFilter, translate } from "app/filters/i18nFilter";
import { handleCTAClick, TestCases } from "app/common/utils/handleGainAccessRedirect";
import { DurationSelectorSimple } from "app/components/duration-selector/DurationSelectorSimple";
import { FixedDurationsSelector } from "app/components/duration-selector/FixedDurationsSelector";
import { updateFilterConsistencyCountry } from "app/routes/handlers/filter-consistency/filterConsistencyUtils";
import { PreferencesService } from "app/services/preferences/preferencesService";
import { EHooksVersions } from "app/services/SwHook";
import { allTrackers } from "app/services/track/track";
import { isNoTouch } from "app/UtilitiesAndConstants/UtilityFunctions/trialUsersUtils";
import { DurationSelectorPresetOriented } from "pro-features/components/duration-selectors/DurationSelectedPresetOriented";
import { IndicatorTypes } from "pro-features/components/duration-selectors/DurationSelectedPresetOriented/types";
import type { IUnlockModalConfigTypes } from "pro-features/components/Modals/src/UnlockModal/unlockModalConfig";
import unlockModalConfig from "pro-features/components/Modals/src/UnlockModal/unlockModalConfig";
import { FilterChangedNotification } from "pro-features/components/tooltips/src/DMIFilterTooltip/FilterEducationTooltip";
import { EFilterChangedTooltipTypes } from "pro-features/components/tooltips/src/filterChangedTooltip/FilterChangedTooltipTypes";
import { proNavigator } from "single-spa/react-app/ProNavigator";

const i18n = i18nFilter();

interface DemandAnalysisFiltersComponentProps {
    [prop: string]: any;
}

class DemandAnalysisFiltersComponent extends FiltersBase<DemandAnalysisFiltersComponentProps, any> {
    private stateChangeSuccessHandler;

    constructor(props) {
        super(props);
        const params = this.services.swNavigator.getParams();
        const state = this.services.swNavigator.current();
        const stateParams = this.getStateParams(params, state);
        const selectedDuration = params.duration;
        const countryFilterDisabled = this.isCountryDropDownDisabled(state);
        const durationSelectorDisabled = this.isDurationSelectorDisabled(state);
        const countryFilterDisabledTooltip = params?.isTopic && translate("dmi.country.filter.topics.disabled.tooltip");
        const keys = this.getKeys(params);

        const TooltipChangeProps = {
            preferencesKey: state.customData?.countryFilterPreferencesKey,
            onTooltipVisible: () =>
                PreferencesService.add({
                    [this.state.customData?.countryFilterPreferencesKey]: true,
                }),
            firstTooltipTitle: i18n("dmi.country.filter.change.first.title"),
            tooltipTitle: i18n("dmi.country.filter.change.title"),
            firstTooltipBody: i18n("dmi.country.filter.change.first.body"),
            tooltipBody: i18n("dmi.country.filter.change.body"),
            filterType: EFilterChangedTooltipTypes.COUNTRY_PICKER,
        };
        this.state = {
            componentName: this.services.swSettings.current.componentId,
            isSideBarOpen: false,
            keys,
            ...stateParams,
            durationSelectorDisabled,
            selectedDuration,
            countryFilterDisabled,
            isCountryHookOpen: false,
            durationPaymentHook: this.services.swSettings.current.durationPaymentHook,
            comparedDurationAllowed: state.periodOverPeriodEnabled === true,
            TooltipChangeProps,
            skipFilterConsistency: state.skipFilterConsistency,
            showWebSource: state.data?.filtersConfig?.webSource !== FiltersEnum.HIDDEN,
            countryFilterDisabledTooltip,
        };
    }

    public render() {
        return (
            <div className="react-filters-container">
                <FiltersBar filters={this.getFilters()} />
            </div>
        );
    }

    public componentDidMount() {
        const router = this.props.router;
        this.stateChangeSuccessHandler = router.transitionService.onSuccess({}, (transition) =>
            this.onStateChangeSuccess(null, transition.to(), transition.params()),
        );
    }

    public componentWillUnmount() {
        this.stateChangeSuccessHandler();
    }

    @autobind
    private onSortChange(sortingType = null) {
        this.setState({
            availableCountries: utils.getCountries(false, swSettings.current, sortingType),
        });
    }

    @autobind
    private onStateChangeSuccess(evt, toState, toParams) {
        if (!this.isCorrectState(toState)) {
            return;
        }
        const stateParams = this.getStateParams(toParams, toState);
        const countryFilterDisabled = this.isCountryDropDownDisabled(toState);
        const durationSelectorDisabled = this.isDurationSelectorDisabled(toState);
        const keys = this.getKeys(toParams);

        this.setState({
            ...this.state,
            ...stateParams,
            keys,
            countryFilterDisabled,
            durationSelectorDisabled,
            durationPaymentHook: this.services.swSettings.current.durationPaymentHook,
            selectedDuration: toParams.duration,
            skipFilterConsistency: toState.skipFilterConsistency,
        });
    }

    private getKeys(params: RawParams): string | string[] {
        return params.keywordGroup || params.topic || params.searchTerm || "";
    }

    private getStateParams(params, state) {
        const countryFilterPreferencesKey = state.customData?.countryFilterPreferencesKey;
        const excludeStates = state.isUSStatesSupported === undefined ? false : !state.isUSStatesSupported;
        const countryFilterInitialSortingType =
            typeof state.customData?.countryFilterInitialSortingType === "function"
                ? state.customData?.countryFilterInitialSortingType(params.keyword)
                : state.customData?.countryFilterInitialSortingType;

        const availableCountries = utils.getCountries(
            excludeStates,
            swSettings.current,
            countryFilterInitialSortingType,
        );
        const availableWebsource = this.getWebSources(state, params);
        const isCountryFilterAllowData =
            typeof state.customData?.isCountryFilterAllowData === "function"
                ? state.customData?.isCountryFilterAllowData(params.keyword)
                : state.customData?.isCountryFilterAllowData;
        const countryFilterSortingText = state.customData?.countryFilterSortingText;
        let selectedCountry = find<{ id: number }>(availableCountries, {
            id: parseInt(params.country),
        });
        if (!selectedCountry) {
            if (swSettings.current.resources.initialCountry) {
                selectedCountry = availableCountries.find(
                    ({ id }) => id === swSettings.current.resources.initialCountry,
                );
            }
            if (!selectedCountry) {
                selectedCountry = get(availableCountries, 0, {});
            }
            this.services.swNavigator.updateParams({
                country: selectedCountry?.id.toString(),
            });
        }
        const selectedWebSource = find(availableWebsource, { id: params.webSource });
        const showClusters = params.showClusters === "true";

        return {
            availableCountries,
            availableWebsource,
            selectedCountry,
            selectedWebSource,
            showClusters,
            minDate: this.services.swSettings.current.startDate,
            maxDate: this.services.swSettings.current.endDate,
            durationSelectorPresets: this.services.swSettings.current.datePickerPresets,
            isCountryFilterAllowData,
            countryFilterSortingText,
            countryFilterInitialSortingType,
            isUSStatesSupported: !excludeStates,
            countryFilterPreferencesKey,
            selectedComparedDuration: params.comparedDuration,
        };
    }

    @autobind
    private getWebSources(state, params) {
        return utils.getAvailableWebSource(state, params);
    }

    @autobind
    private onCountryChange(country) {
        this.trackFilterValue(`Header/Country Filter/${country.text}`);
        if (!this.state.skipFilterConsistency) {
            updateFilterConsistencyCountry(country.id);
        }
        this.services.swNavigator.updateParams({
            country: country.id,
            isCountryChanged: null,
        });
    }

    private getFilters(): IFilter[] {
        const selectedCountryId = utils.getSelectedId(this.state.selectedCountry);
        const selectedWebSource = utils.getSelectedId(this.state.selectedWebSource);
        const isCountryChanged = !!proNavigator.getParams()?.isCountryChanged;

        const filters = [
            {
                id: "duration",
                filter: this.getDurationSelectorComponent(false),
            },
            {
                id: "country",
                key: "country",
                filter: (
                    <div key="filter-country">
                        <PlainTooltip
                            text={this.state.countryFilterDisabledTooltip}
                            enabled={!!this.state.countryFilterDisabledTooltip}
                            placement="bottom"
                        >
                            <div>
                                <CountryFilter
                                    presentNotificationIndicator={isCountryChanged}
                                    presentNotificationTooltipKey={
                                        "website.analysis.present.country.notification.tooltip"
                                    }
                                    countryFilterInitialSortingType={
                                        this.state.customData?.countryFilterInitialSortingType
                                    }
                                    sortChange={this.onSortChange}
                                    isCountryFilterAllowData={this.state.customData?.isCountryFilterAllowData}
                                    countryFilterSortingText={this.state.customData?.countryFilterSortingText}
                                    isUSStatesSupported={this.state.isUSStatesSupported}
                                    key="filter-country"
                                    appendTo="body"
                                    availableCountries={this.state.availableCountries}
                                    changeCountry={this.onCountryChange}
                                    selectedCountryIds={selectedCountryId !== null ? selectedCountryId : {}}
                                    disabled={this.state.countryFilterDisabled}
                                    showUpgradeHook={
                                        isNoTouch()
                                            ? !this.services.swNavigator.current().data.disableNoTouchForCountryFilter
                                            : undefined
                                    }
                                    height={60}
                                    onToggle={this.trackFilterDropDownStatus("Header/Country Filter")}
                                    itemWrapper={(props) => (
                                        <div
                                            onClick={() => {
                                                handleCTAClick(
                                                    EHooksVersions.V5,
                                                    "WebCountry",
                                                    TestCases.TRIAL_AFTER_TRIAL,
                                                );
                                            }}
                                        >
                                            {props.children}
                                        </div>
                                    )}
                                />
                            </div>
                        </PlainTooltip>
                    </div>
                ),
            },
        ];
        if (this.state.availableWebsource.length > 0 && selectedWebSource && this.state.showWebSource) {
            filters.push({
                id: "webSource",
                key: "webSource",
                filter: this.getWebSourceFilterComponent(this.props.showWebSourceTooltip, selectedWebSource),
            });
        }
        return filters;
    }

    private getWebSourceFilterComponent(wrapWithTooltip = false, selectedWebSource) {
        const activeSlide: IUnlockModalConfigTypes["DeviceFilters"] = "Devices";
        const isWebSourceChanged = !!proNavigator.getParams()?.isWebSourceChanged;
        const component = (
            <div key="filter-websource">
                <WebSourceFilter
                    appendTo="body"
                    items={this.state.availableWebsource}
                    onChange={this.onWebSourceChange}
                    selectedIds={selectedWebSource}
                    height={60}
                    onToggle={this.trackFilterDropDownStatus("Header/WebSource Filter")}
                    disabled={this.state.availableWebsource.length === 1}
                    presentNotificationIndicator={isWebSourceChanged}
                    presentNotificationTooltipKey={"website.analysis.present.webSource.notification.tooltip"}
                    itemWrapper={(props) => (
                        <div
                            onClick={() => {
                                this.setState({ isWebSourceHookOpen: true });
                                allTrackers.trackEvent(
                                    "hook/Contact Us/Pop Up",
                                    "click",
                                    `WebSource Filter/${props.text}`,
                                );
                            }}
                        >
                            {props.children}
                        </div>
                    )}
                />
                <UnlockModal
                    isOpen={this.state.isWebSourceHookOpen}
                    onCloseClick={() => {
                        this.setState({ isWebSourceHookOpen: false });
                    }}
                    activeSlide={activeSlide}
                    location="Hook PRO/Website Analysis/Web Source Filter"
                    {...unlockModalConfig().DeviceFilters}
                />
            </div>
        );
        return wrapWithTooltip ? (
            <div
                className="scss-tooltip scss-tooltip--s scss-tooltip--autohiding"
                data-scss-tooltip={i18n("wa.overview.websource.tooltip")}
            >
                {component}
            </div>
        ) : (
            component
        );
    }

    @autobind
    private getFilterChangedNotification() {
        return <FilterChangedNotification {...this.state.TooltipChangeProps} />;
    }

    private isCountryDropDownDisabled(state) {
        return state.data?.filtersConfig?.country === FiltersEnum.DISABLED;
    }

    private isDurationSelectorDisabled(state) {
        return state.data?.filtersConfig?.duration === FiltersEnum.DISABLED;
    }

    @autobind
    private onWebSourceChange(webSource) {
        const currentWebSource = this.services.swNavigator.getParams().webSource;
        if (!this.state.skipFilterConsistency) {
            this.props.webSourceSelected(webSource.id);
        }
        if (currentWebSource === webSource.id) {
            return;
        }
        this.trackFilterValue(`Header/WebSource Filter/${webSource.text}`);
        this.services.swNavigator.updateQueryParams({
            webSource: webSource.id,
            isWebSourceChanged: null,
        });
    }

    private getDurationSelectorComponent(wrapWithTooltip = false) {
        const current = this.services.swNavigator.current();
        const params = this.services.swNavigator.getParams();
        const { isDurationChanged } = params;

        const isFixedSnapshotRangeLength = typeof swSettings.current.resources.FixedSnapshotRangeLength === "number";
        const { isShortMonthIntervalsUser } = this.services.swSettings.user;

        const ComponentClass = isFixedSnapshotRangeLength ? FixedDurationsSelector : DurationSelectorSimple;
        let { hideCalendar } = current;
        // set hideCalendar to true in case the current component uses FixedSnapshotRangeLength.
        // We do that in order to "apply" the changes immediately after preset selection
        if (isFixedSnapshotRangeLength) {
            hideCalendar = true;
        }
        const presentNotificationForDurationChanged = isDurationChanged === true;

        const component =
            isFixedSnapshotRangeLength || !isShortMonthIntervalsUser ? (
                <ComponentClass
                    key="filter-duration"
                    minDate={this.state.minDate}
                    maxDate={this.state.maxDate}
                    isDisabled={this.state.durationSelectorDisabled}
                    presets={preparePresets(this.state.durationSelectorPresets)}
                    initialPreset={this.state.selectedDuration}
                    initialComparedDuration={this.state.selectedComparedDuration}
                    onSubmit={this.onDurationChange}
                    componentName={this.state.componentName}
                    keys={this.state.keys}
                    disableCalendar={hideCalendar}
                    disableFooter={hideCalendar}
                    compareAllowed={this.state.comparedDurationAllowed}
                    hasPermissionsLock={this.state.durationPaymentHook}
                    presentNotificationIndicator={presentNotificationForDurationChanged}
                    presentNotificationTooltipKey={"website.analysis.present.duration.notification.tooltip"}
                    appendTo="body"
                    compareLabel={translate("websiteanalysis.duration.compare.label")}
                    compareDisabledTooltipText={translate("categoryanalysis.duration.compare.disabled.tooltip")}
                />
            ) : (
                <DurationSelectorPresetOriented
                    minDate={this.state.minDate}
                    maxDate={this.state.maxDate}
                    isDisabled={this.state.durationSelectorDisabled}
                    onSubmit={this.onDurationChange}
                    presets={preparePresets(this.state.durationSelectorPresets)}
                    initialPreset={this.state.selectedDuration}
                    disableCalendar={hideCalendar}
                    presentNotificationIndicator={presentNotificationForDurationChanged}
                    presentNotificationTooltipKey={"website.analysis.present.duration.notification.tooltip"}
                    indicatorType={IndicatorTypes.DOT}
                />
            );

        const componentWithPeriodOverPeriodToggle = <PeriodOverPeriodWrapper>{component}</PeriodOverPeriodWrapper>;
        return wrapWithTooltip ? (
            <PlainTooltip
                cssClassContent="filters-bar-tooltip"
                placement={"bottom"}
                text={this.state.invalidDurationTooltipMessage}
            >
                <div>{componentWithPeriodOverPeriodToggle}</div>
            </PlainTooltip>
        ) : (
            componentWithPeriodOverPeriodToggle
        );
    }

    @autobind
    private onSidebarListCompactElementItemChangeProp(item, cb) {
        return async () => {
            await this.setStateAsync({
                isSideBarOpen: false,
            });
            setTimeout(() => {
                cb(item);
            }, 400);
        };
    }

    @autobind
    private onDurationChange(duration, comparedDuration) {
        if (!this.state.skipFilterConsistency) {
            this.props.durationSelected(duration);
        }
        this.services.swNavigator.updateParams({
            duration,
            comparedDuration: comparedDuration ? comparedDuration : "",
            isDurationChanged: null,
        });
    }

    @autobind
    private async onDurationChangeFromSideBar(x, y) {
        await this.setStateAsync({
            isSideBarOpen: false,
        });
        setTimeout(() => {
            this.onDurationChange(x, y);
        }, 400);
    }

    @autobind
    private isCorrectState(toState) {
        return this.services.swNavigator.isKeywordAnalysis(toState);
    }
}

function mapDispatchToProps(dispatch) {
    return {
        durationSelected: (duration) => {
            dispatch(durationFilterDSSelected(duration));
        },
        webSourceSelected: (webSource) => {
            dispatch(webSourceFilterDSSelected(webSource));
        },
    };
}

export const DemandAnalysisFilters = connect(null, mapDispatchToProps)(withUIRouter(DemandAnalysisFiltersComponent));
